module.exports = __webpack_public_path__ + "img/Icon metro-switch.048e403a.svg";